import { Card } from 'react-bootstrap';
import { isEmpty, truncate } from 'lodash';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Badges } from '../cards-filter/Badges';

const ExperienceCard = ({
  title,
  previewImage,
  previewText,
  url,
  target,
  fromPrice,
  productPrice,
  productSalePrice,
  productPriceDefinition,
  badgeText,
  badges,
}) => {
  const isOnSale =
    !!productSalePrice && !!window.ecom.craftConfig.showMarketingDiscounts;
  const savedMoney = isOnSale ? productPrice - productSalePrice : 0;

  return (
    <a
      className="h-100 d-block text-reset text-decoration-none card-badge__container image-hover"
      href={url}
      target={target || '_self'}
    >
      <Card className="h-100 overflow-hidden">
        <div className="overflow-hidden">
          <Card.Img
            loading="lazy"
            variant="top"
            src={previewImage.url}
            width={previewImage.width}
            height={previewImage.height}
            alt={previewImage.alt}
          />
        </div>
        <Card.Body className="d-flex flex-column gap-2">
          <h2 className="h3">{title}</h2>
          {parse(truncate(previewText, { length: 200, separator: ' ' }))}
        </Card.Body>
        <Card.Footer className="bg-white border-top-0">
          <div className="text-grey">
            {fromPrice && <div className="text-x-small">From</div>}
            <div>
              <span className="fw-bold text-primary text-xx-large">
                ${isOnSale ? productSalePrice : productPrice}
              </span>
              {productPriceDefinition && (
                <span className="text-large">
                  &nbsp;{productPriceDefinition}
                </span>
              )}
            </div>
            {isOnSale && (
              <div>
                Normally <del>${productPrice}</del>.&nbsp;
                <span className="fw-bold">Save ${savedMoney}.</span>
              </div>
            )}
          </div>
        </Card.Footer>
      </Card>
      {!isEmpty(badges) && <Badges badges={badges} />}
      {isEmpty(badges) && badgeText && (
        <div className="card-badge__badge">{badgeText}</div>
      )}
    </a>
  );
};
export default ExperienceCard;

ExperienceCard.propTypes = {
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string,
  }),
  previewText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  target: PropTypes.string,
  fromPrice: PropTypes.bool,
  productPrice: PropTypes.number.isRequired,
  productSalePrice: PropTypes.number,
  productPriceDefinition: PropTypes.string,
  badgeText: PropTypes.string,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      badgeIcon: PropTypes.string,
      badgeColour: PropTypes.string,
      badgeTextColour: PropTypes.string,
    })
  ),
};
